export default __webpack_public_path__ + "static/media/limited_drinks@2x.43666902.jpg";